import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { components } from '@atlaskit/select';

export type LoadingMenuProps = {
	children: ReactNode;
	testId?: string;
};

// exported for storybook only
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ComponentsMenu = (props: any) => {
	const { children, ...rest } = props;

	return <components.Menu {...rest}>{children}</components.Menu>;
};

export const LoadingMenu = (props: LoadingMenuProps) => {
	const { children, ...rest } = props;
	return (
		<Wrapper>
			<ComponentsMenu {...rest}>{children}</ComponentsMenu>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	position: 'absolute',
	top: 0,
	width: '100%',
});
